import { makeAutoObservable } from "mobx";

export default class InformationProcessStore {
	constructor() {
		this._tenders = [];
		this._acquisition = [];
		this._vacancies = [];

		this._consultation = [];
		this._initiation = [];
		this._draftDecisions = [];
		this._recommendations = [];
		this._publicNotices = [];

		this._tendersPage = 1;
		this._acquisitionPage = 1;
		this._vacanciesPage = 1;
		this._consultationPage = 1;
		this._initiationPage = 1;
		this._recommendationsPage = 1;
		this._draftDecisionsPage = 1;
		this._publicNoticesPage = 1;

		this._tendersTotalCount = 0;
		this._acquisitionTotalCount = 0;
		this._vacanciesTotalCount = 0;
		this._consultationTotalCount = 0;
		this._initiationTotalCount = 0;
		this._recommendationsTotalCount = 0;
		this._draftDecisionsTotalCount = 0;
		this._publicNoticesTotalCount = 0;

		this._tendersLimit = 5;
		this._acquisitionLimit = 5;
		this._vacanciesLimit = 5;
		this._consultationLimit = 5;
		this._initiationLimit = 5;
		this._recommendationsLimit = 5;
		this._draftDecisionsLimit = 5;
		this._publicNoticesLimit = 5;

		makeAutoObservable(this);
	}

	setTenders(tenders) {
		this._tenders = tenders;
	}

	get tenders() {
		return this._tenders;
	}

	setAcquisition(acquisition) {
		this._acquisition = acquisition;
	}

	get acquisition() {
		return this._acquisition;
	}

	setVacancies(vacancies) {
		this._vacancies = vacancies;
	}

	get vacancies() {
		return this._vacancies;
	}

	setConsultation(consultation) {
		this._consultation = consultation;
	}

	get consultation() {
		return this._consultation;
	}

	setInitiation(initiation) {
		this._initiation = initiation;
	}

	get initiation() {
		return this._initiation;
	}

	setRecommendations(recommendations) {
		this._recommendations = recommendations;
	}

	get recommendations() {
		return this._recommendations;
	}

	setDraftDecisions(draftDecisions) {
		this._draftDecisions = draftDecisions;
	}

	get draftDecisions() {
		return this._draftDecisions;
	}

	setPublicNotices(publicNotices) {
		this._publicNotices = publicNotices;
	}

	get publicNotices() {
		return this._publicNotices;
	}

	setTendersPage(page) {
		this._tendersPage = page;
	}
	get tendersPage() {
		return this._tendersPage;
	}

	setAcquisitionPage(page) {
		this._acquisitionPage = page;
	}
	get acquisitionPage() {
		return this._acquisitionPage;
	}

	setVacanciesPage(page) {
		this._vacanciesPage = page;
	}
	get vacanciesPage() {
		return this._vacanciesPage;
	}

	setConsultationPage(page) {
		this._consultationPage = page;
	}
	get consultationPage() {
		return this._consultationPage;
	}

	setInitiationPage(page) {
		this._initiationPage = page;
	}
	get initiationPage() {
		return this._initiationPage;
	}

	setRecommendationsPage(page) {
		this._recommendationsPage = page;
	}
	get recommendationsPage() {
		return this._recommendationsPage;
	}

	setDraftDecisionsPage(page) {
		this._draftDecisionsPage = page;
	}
	get draftDecisionsPage() {
		return this._draftDecisionsPage;
	}

	setPublicNoticesPage(page) {
		this._publicNoticesPage = page;
	}
	get publicNoticesPage() {
		return this._publicNoticesPage;
	}

	setTendersTotalCount(count) {
		this._tendersTotalCount = count;
	}
	get tendersTotalCount() {
		return this._tendersTotalCount;
	}

	setAcquisitionTotalCount(count) {
		this._acquisitionTotalCount = count;
	}
	get acquisitionTotalCount() {
		return this._acquisitionTotalCount;
	}

	setVacanciesTotalCount(count) {
		this._vacanciesTotalCount = count;
	}
	get vacanciesTotalCount() {
		return this._vacanciesTotalCount;
	}

	setConsultationTotalCount(count) {
		this._consultationTotalCount = count;
	}
	get consultationTotalCount() {
		return this._consultationTotalCount;
	}

	setInitiationTotalCount(count) {
		this._initiationTotalCount = count;
	}
	get initiationTotalCount() {
		return this._initiationTotalCount;
	}

	setRecommendationsTotalCount(count) {
		this._recommendationsTotalCount = count;
	}
	get recommendationsTotalCount() {
		return this._recommendationsTotalCount;
	}

	setDraftDecisionsTotalCount(count) {
		this._draftDecisionsTotalCount = count;
	}
	get draftDecisionsTotalCount() {
		return this._draftDecisionsTotalCount;
	}

	setPublicNoticesTotalCount(count) {
		this._publicNoticesTotalCount = count;
	}
	get publicNoticesTotalCount() {
		return this._publicNoticesTotalCount;
	}

	setTendersLimit(limit) {
		this._tendersLimit = limit;
	}
	get tendersLimit() {
		return this._tendersLimit;
	}

	setAcquisitionLimit(limit) {
		this._acquisitionLimit = limit;
	}
	get acquisitionLimit() {
		return this._acquisitionLimit;
	}

	setVacanciesLimit(limit) {
		this._vacanciesLimit = limit;
	}
	get vacanciesLimit() {
		return this._vacanciesLimit;
	}

	setConsultationLimit(limit) {
		this._consultationLimit = limit;
	}
	get consultationLimit() {
		return this._consultationLimit;
	}

	setInitiationLimit(limit) {
		this._initiationLimit = limit;
	}
	get initiationLimit() {
		return this._initiationLimit;
	}

	setRecommendationsLimit(limit) {
		this._recommendationsLimit = limit;
	}
	get recommendationsLimit() {
		return this._recommendationsLimit;
	}

	setDraftDecisionsLimit(limit) {
		this._draftDecisionsLimit = limit;
	}
	get draftDecisionsLimit() {
		return this._draftDecisionsLimit;
	}

	setPublicNoticesLimit(limit) {
		this._publicNoticesLimit = limit;
	}
	get publicNoticesLimit() {
		return this._publicNoticesLimit;
	}
}
